// Loader for the Talmundo Chatbot web component (v3.1.0)
// This file is required automatically by src/app/talentechImport.js via require.context
(function () {
  try {
    var tagName = 'talmundo-chatbot';
    var cdnUrl = 'https://storybook-wc.talentech.io/talmundo/talmundo-chatbot/6.4.0/talmundoChatbot.dist.js';

    if (window.customElements && window.customElements.get && window.customElements.get(tagName)) {
      return;
    }

    var existing = document.querySelector('script[src="' + cdnUrl + '"]');
    if (existing) {
      return;
    }

    var s = document.createElement('script');
    s.src = cdnUrl;
    s.async = true;
    document.head.appendChild(s);
  } catch (e) {
    try {
      console.warn('[talmundo-chatbot] loader failed', e);
    } catch (err) { }
  }
})();
